import { SanitizeLevel } from '@openreplay/tracker'

// Only SSNs, tax ids, bank account details and passwords are sensitive; ops and compliance need everything else visible.
const SENSITIVE_FIELD_NAME_PATTERN = /ssn|socialsecurity|taxid|routing|accountnumber|password/i
const EMPLOYER_IDENTIFICATION_NUMBER_FIELD_NAME = 'ein'

const isSensitiveFieldName = (fieldName: string | null): boolean => {
    if (fieldName === null) {
        return false
    }
    const normalizedFieldName = fieldName.replace(/[^a-z0-9]/gi, '')
    return SENSITIVE_FIELD_NAME_PATTERN.test(normalizedFieldName) || normalizedFieldName.toLowerCase() === EMPLOYER_IDENTIFICATION_NUMBER_FIELD_NAME
}

/** Whether this element itself is marked data-pii or is a sensitive field; the tracker and Live View carry it down to descendants. */
export const isOpenReplaySensitiveElement = (element: Element): boolean => element.hasAttribute('data-pii') || isSensitiveFieldName(element.getAttribute('name'))

export const resolveOpenReplaySanitizeLevelForElement = (element: Element): SanitizeLevel => (isOpenReplaySensitiveElement(element) ? SanitizeLevel.Obscured : SanitizeLevel.Plain)
